var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModeStrength(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Strengthen"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    d: "M0 40C0 62.0912 17.9088 80 40 80C62.0912 80 80 62.0912 80 40C80 17.9088 62.0912 0 40 0C17.9088 0 0 17.9088 0 40Z",
    fill: "url(#paint0_linear_2850_35)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "flagpole",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8772 14.8982C31.4011 14.6247 31.0808 14.1133 31.0808 13.5276C31.0808 12.6536 31.7939 11.9452 32.6737 11.9452C33.5536 11.9452 34.2667 12.6536 34.2667 13.5276C34.2667 14.1134 33.9463 14.6248 33.4701 14.8983V42.7554H31.8772V14.8982Z",
    fill: "#FFCD3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "banner",
    d: "M50.7007 14.7309V27.2338C42.581 30.3131 40.8611 24.5042 33.4567 27.5988V15.0906C40.8611 11.996 42.581 17.8102 50.7007 14.7309Z",
    fill: "#FFCD3D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pinnaclebody",
    d: "M60.5069 74.3625C54.5185 77.9377 47.5049 80 40.008 80C37.7678 80 35.5675 79.817 33.4271 79.461C24.1685 77.9329 15.9893 73.2301 10.071 66.5197L20.9725 50.2808L32.6752 37.8143L44.1443 49.9691L48.6396 56.6747L51.895 61.5257L60.5069 74.3625Z",
    fill: "#0A5960"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pinnacle",
    d: "M44.1451 49.9345V50.2805C44.1451 52.0855 42.6616 53.5545 40.8446 53.5545C36.9419 53.5545 36.1157 47.7392 32.8401 47.7392C30.1725 47.7392 30.4258 50.2805 27.1804 50.2805H20.9728L24.3578 45.2665L32.6813 32.8596L44.1451 49.9345Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peakbody",
    d: "M70.2239 66.2034C67.4559 69.4077 64.1756 72.1722 60.507 74.3627C54.5187 77.9378 47.505 79.9997 40.0082 79.9997C37.768 79.9997 35.5676 79.8166 33.4272 79.4606L48.6349 56.6796L48.6397 56.6743L56.2507 50.2214L61.2685 52.7927L70.2239 66.2034Z",
    fill: "#146C78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "peak",
    d: "M61.2936 52.7789C61.2289 54.9346 59.4469 56.6657 57.2566 56.6657H48.615L56.251 45.2773L61.2936 52.7789Z",
    fill: "#FEFEFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2850_35",
    x1: 57.4074,
    y1: 2.22222,
    x2: 18.1481,
    y2: 77.7778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DCADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047583"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeStrength);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;